import { render, staticRenderFns } from "./V2ProfileButton.vue?vue&type=template&id=7603590c&scoped=true&"
import script from "./V2ProfileButton.vue?vue&type=script&lang=js&"
export * from "./V2ProfileButton.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileButton.vue?vue&type=style&index=0&id=7603590c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7603590c",
  null
  
)

export default component.exports